<template>
  <div>
    <el-row style="display: flex;margin-bottom: 10px;">
      <el-col :span="4" v-if="theProjectId== 0" >
        <el-select v-model="form.projectId" @change="theProjectAllChange" size="small" filterable clearable
          placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
      </el-col>

    </el-row>
    <div>

        <mytable
          :tableColums='tableColums_getUserPropSpecialistList'
          api='getUserPropSpecialistList'
          xupdateapi='updateOpportunityBusinessCheckImage'
          :height="H-165" >
        </mytable>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return {
        theProjectId:0,
        value:'',
        form:{
          projectId:'',
          yasDate:'',
          yasCommand:'',
          yasTimeStart:'',
          yasTimeEnd:'',
          yasDes:'',
        },
        tableColums_getUserPropSpecialistList:{
          $selection: false,

          // oiType: '限制字段key',
          createusername:'学员',
          yupsTimeStart:'开始时间',
          yupsTimeEnd:'结束时间',
          yupsContext: '问题描述',
          yupsName:'支撑专家',
          yupsStatusDes:'拒绝理由',
          yupsStatus:['状态',,'@v-if: 1:已提出,2:已接受, 3:已拒绝, 4:已过期,5:已取消'],
          createtime:'创建时间',
          $operation: [
            '操作', 200,
            this.agreeUserPropSpecialist && `@text: 同意#success
              @v-if:$row.yupsStatus == 1
             @click: _confirm('确定要同意吗?')
                     .trigger('agreeUserPropSpecialist',{yupsId:$row.yupsId})
                     .trigger('getUserPropSpecialistList',{projectId:form.projectId})

            `,
            this.deleteUserPropSpecialist && `@text: 取消#danger
             @v-if:$row.yupsStatus == 2
             @click: _confirm('确定要取消吗?')
                     .trigger('deleteUserPropSpecialist',{yupsId:$row.yupsId})
                     .trigger('getUserPropSpecialistList',{projectId:form.projectId})
            `,
            this.refuseUserPropSpecialist && `@text: 拒绝#danger
             @v-if: $row.yupsStatus == 1
             @click:Refuse($row)
            `,
          ],
        }
      }
    },
    methods:{
      Refuse(row){
          this.$prompt('请拒绝理由', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                  }).then(({ value }) => {
                   this.refuseUserPropSpecialist({yupsId:row.yupsId,yupsStatusDes:value}).result(res=>{
                     this.$message({
                       type: 'success',
                       message: '成功'
                     })
                      this.getUserPropSpecialistList({projectId:this.form.projectId})
                   })
                  }).catch(() => {
                    this.$message({
                      type: 'info',
                      message: '取消'
                    });
                  });
      },
      myform(submit, Myformdata){
        Myformdata.projectId = this.form.projectId;
           submit();
      },
      theProjectAllChange(e){
        if(e == ''){
          return  this.form.projectId = e;
        }
        this.form.projectId = e;
        this.getUserPropSpecialistList({projectId:this.form.projectId})
      },
    },
    created(){
      this.getProjectList({
        pageSize: 0
      });

      this.theProjectId = A.local("$projectId");
      if (this.theProjectId != 0) {
        this.form.projectId = this.theProjectId;
      }
      this.getUserPropSpecialistList({projectId:this.form.projectId})
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bussiness/ExpertSupport.vue